// Tool and vendor kinds arrive snake_case at runtime (`grail_pay`) though the generated types say
// `GrailPay`, so lookups compare them with case and separators removed.
const squashKind = (value: string) => value.toLowerCase().replace(/[^a-z0-9]/g, '');

export default squashKind;
